import { FileCheck2 } from "lucide-react";
import { LegalPageShell } from "@/components/legal/LegalPageShell";

// Página pública. Accesible SIN sesión. Ruta declarada en App.js: /terminos-y-condiciones.
// Oct-2026 · Términos y Condiciones de Uso de FELVORA (texto legal completo proporcionado
// por el product owner, versión 2026-10-16). NO modificar el texto sin autorización del PO.
export default function TerminosYCondiciones() {
  return (
    <LegalPageShell
      testId="terminos-y-condiciones-page"
      icon={<FileCheck2 className="h-5 w-5 text-primary" />}
      kicker="Condiciones de uso de la plataforma"
      titulo="Términos y Condiciones de Uso">
      <p className="text-sm leading-relaxed text-slate-700">
        Estos Términos y Condiciones regulan el uso de la plataforma FELVORA, que Servicios
        Legales y Fiscales BLC, S.C. presta a las entidades que la contratan. Al marcar la
        casilla de aceptación, la entidad y el usuario que la representa quedan obligados por
        ellos.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        1. Partes y aceptación
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        El prestador es Servicios Legales y Fiscales BLC, S.C., con RFC SLF251209LRA y domicilio
        en Avenida Tlaxcala Sur 36 B, Papalotla de Xicohténcatl, Tlaxcala, C.P. 90790 ("FELVORA").
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        El cliente es la persona moral o física que se registra en la plataforma ("la Entidad"),
        representada por el usuario que realiza el registro, quien declara contar con facultades
        suficientes para obligarla.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        La Entidad acepta estos Términos por medios electrónicos al marcar la casilla de
        aceptación. Esa aceptación constituye consentimiento expreso conforme al artículo 1803
        del Código Civil Federal y tiene plena validez como mensaje de datos conforme al Código
        de Comercio. FELVORA conserva constancia de la fecha, hora, usuario y versión aceptada.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        2. Objeto del servicio
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        FELVORA otorga a la Entidad una licencia de uso no exclusiva, intransferible y temporal
        de la plataforma, en la modalidad de software como servicio, durante la vigencia de su
        suscripción.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        La plataforma es una herramienta tecnológica de apoyo para la gestión de cumplimiento
        regulatorio, originación y administración de cartera, prevención de lavado de dinero y
        obligaciones fiscales. Los módulos disponibles dependen del plan contratado.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        La suscripción no incluye asesoría jurídica, fiscal o de cumplimiento. Esos servicios, en
        su caso, se contratan por separado.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        3. Planes, pagos y facturación
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        El precio, los módulos y los cupos de cada plan son los publicados en la plataforma al
        momento de la contratación, más el IVA correspondiente. La suscripción tiene un plazo
        forzoso mínimo de 12 meses contados desde la contratación.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Se cobra por periodos recurrentes, por adelantado, mediante el procesador de pagos de la
        plataforma. La Entidad autoriza el cargo automático al medio de pago registrado.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Las consultas a servicios externos que excedan el cupo del plan, como la consulta de
        listas, pueden generar cargos adicionales según las tarifas publicadas.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Si un pago no se realiza, FELVORA puede suspender el acceso después de [5] días naturales
        de aviso. La información se conserva durante la suspensión.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        FELVORA puede modificar los precios avisándolo con al menos [30] días naturales de
        anticipación; el cambio aplica desde el siguiente periodo.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Los pagos realizados no son reembolsables, salvo error de cobro imputable a FELVORA.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        4. Obligaciones y responsabilidad regulatoria de la Entidad
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">La Entidad se obliga a:</p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-700">
        <li>Proporcionar información veraz, completa y actualizada, incluida la de sus clientes.</li>
        <li>
          Administrar las cuentas de sus usuarios, asignar los roles que correspondan y mantener
          la confidencialidad de sus credenciales.
        </li>
        <li>
          Contar con la autorización o el consentimiento de sus clientes para tratar sus datos y
          consultarlos en sociedades de información crediticia y listas, cuando la ley lo exija.
        </li>
        <li>Usar la plataforma solo para fines lícitos y conforme a la regulación que le aplica.</li>
      </ul>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        La Entidad es la única responsable de su cumplimiento regulatorio. La plataforma asiste,
        pero no sustituye, las decisiones y obligaciones de la Entidad, de su Oficial de
        Cumplimiento, de su Comité y de sus órganos de gobierno. En particular, son de la
        Entidad: la autorización de créditos, la determinación del grado de riesgo, el dictamen
        de coincidencias en listas, la presentación de reportes ante autoridades y la revisión de
        los documentos que la plataforma genere antes de usarlos.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        5. Datos personales: FELVORA como encargado
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Respecto de los datos personales de los clientes, prospectos, acreditados y demás
        personas que la Entidad captura en la plataforma, la Entidad es la responsable y FELVORA
        actúa como encargado. En consecuencia, FELVORA se obliga a:
      </p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-700">
        <li>Tratar esos datos solo conforme a las instrucciones de la Entidad y para prestar el servicio.</li>
        <li>
          No usarlos para fines propios ni transferirlos, salvo a los proveedores necesarios para
          operar la plataforma o por requerimiento de autoridad competente.
        </li>
        <li>
          Mantener medidas de seguridad administrativas, técnicas y físicas, entre ellas cifrado
          de documentos, control de acceso por roles y separación de la información de cada
          Entidad.
        </li>
        <li>Guardar confidencialidad, aun después de terminada la relación.</li>
        <li>
          Avisar a la Entidad, sin demora injustificada, de cualquier vulneración de seguridad
          que afecte sus datos.
        </li>
        <li>Devolver o suprimir los datos al terminar el contrato, conforme a la cláusula 9.</li>
      </ul>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        La Entidad autoriza a FELVORA a apoyarse en proveedores de hospedaje, correo electrónico,
        pagos, timbrado fiscal y consulta de listas, que tratarán los datos con obligaciones
        equivalentes.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        El tratamiento de los datos de los usuarios de la Entidad se rige por el Aviso de
        Privacidad de FELVORA.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        6. Confidencialidad y propiedad intelectual
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Cada parte guardará confidencialidad sobre la información de la otra que conozca por este
        servicio, durante la vigencia y por [5] años después de su terminación, salvo
        requerimiento de autoridad.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        La plataforma, su código, diseño, marcas, plantillas y metodologías son propiedad de
        FELVORA o de sus licenciantes. La Entidad no adquiere ningún derecho sobre ellos más allá
        de la licencia de uso, y no puede copiarlos, revenderlos, descompilarlos ni ofrecerlos a
        terceros.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        La información que la Entidad captura es de la Entidad.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        7. Disponibilidad, soporte y servicios de terceros
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        FELVORA procurará que la plataforma esté disponible de forma continua, salvo
        mantenimientos programados, que avisará con anticipación cuando sea posible, y causas
        fuera de su control.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        El soporte se brinda por los canales publicados en la plataforma, en días y horas
        hábiles.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Algunas funciones dependen de servicios de terceros, como la consulta de listas, las
        sociedades de información crediticia, el timbrado fiscal y el procesamiento de pagos.
        FELVORA no responde por la disponibilidad, exactitud o cambios de esos servicios, aunque
        informará a la Entidad de las interrupciones que conozca.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        8. Limitación de responsabilidad
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">FELVORA no será responsable por:</p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-700">
        <li>
          Sanciones, multas o requerimientos derivados del incumplimiento regulatorio de la
          Entidad, ni por las decisiones que la Entidad tome con apoyo de la plataforma.
        </li>
        <li>
          Errores causados por información incorrecta, incompleta o desactualizada capturada por
          la Entidad o sus usuarios.
        </li>
        <li>El uso indebido de credenciales por parte de usuarios de la Entidad.</li>
        <li>Daños indirectos o lucro cesante.</li>
      </ul>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        En cualquier caso, la responsabilidad total de FELVORA frente a la Entidad no excederá el
        monto pagado por la Entidad en los [12] meses anteriores al hecho que la origine. Esta
        limitación no aplica en casos de dolo o mala fe.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        9. Vigencia, terminación y entrega de información
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Estos Términos están vigentes mientras la Entidad mantenga una suscripción activa. La
        suscripción tiene un plazo forzoso de 12 meses. Al concluir, se renueva automáticamente
        por periodos iguales de 12 meses, salvo que la Entidad avise su cancelación con al menos
        [30] días naturales de anticipación al vencimiento.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Si la Entidad cancela antes de que concluya el plazo forzoso o su renovación, o si la
        relación termina por causa imputable a ella, deberá pagar las mensualidades pendientes
        hasta completar los 12 meses, que serán exigibles de inmediato.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        FELVORA puede terminar la relación por falta de pago no regularizada, por uso ilícito de
        la plataforma o por incumplimiento grave de estos Términos, avisándolo por escrito.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Al terminar, la Entidad dispondrá de [30] días naturales para descargar su información.
        Después, FELVORA la suprimirá, salvo la que deba conservar por obligación legal.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        La Entidad es responsable de conservar sus expedientes y registros durante los plazos que
        le imponga su regulación.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        10. Modificaciones, ley aplicable y jurisdicción
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        FELVORA puede modificar estos Términos. Publicará la nueva versión en la plataforma y
        pedirá a la Entidad aceptarla al siguiente inicio de sesión. Si la modificación reduce de
        forma sustancial los derechos de la Entidad o aumenta sus obligaciones y la Entidad no la
        acepta, podrá cancelar sin pagar las mensualidades pendientes del plazo forzoso.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Estos Términos se rigen por las leyes federales de los Estados Unidos Mexicanos. Para su
        interpretación y cumplimiento, las partes se someten a los tribunales competentes de
        [Tlaxcala, Tlaxcala], y renuncian a cualquier otro fuero que pudiera corresponderles por
        razón de su domicilio presente o futuro.
      </p>

      <p className="mt-6 text-sm font-medium text-slate-800" data-testid="terminos-fecha-actualizacion">
        Última actualización: 16 de octubre de 2026.
      </p>
    </LegalPageShell>
  );
}
